<form [formGroup]="form" class="pos-relative form">
  <div class="udh-list">
    <div class="row-container" *ngFor="let model of models; let i=index">
      <div class="udh-tlv-row d-flex gap-10">
        <div class="w-50">
          <div class="form-group mb-15">
            <label for="tag" class="form-label">
              Tag [HEX]
            </label>
            <input [(ngModel)]="model.tagHex" [formControlName]="model.controlTagName" type="text" class="form-control" placeholder="Tag [HEX]">
            <input-errors [control]="form.controls[model.controlTagName]" [service]="validationService"></input-errors>
          </div>
          <div class="form-group mb-15">
            <label for="value" class="form-label">
              Value [HEX]
            </label>
            <input [(ngModel)]="model.valueHex" [formControlName]="model.controlValueName" type="text" class="form-control" id="value"
              placeholder="Value [HEX]">
            <input-errors [control]="form.controls[model.controlValueName]" [service]="validationService"></input-errors>
          </div>
        </div>
        <div class="length-info-container w-50 bg-neutral-n2">
          <div class="title">
            Length Info:
          </div>
          <div class="content">
            <div>
              Field Length
              <span class="icon-help-1 text-neutral-n6"
                tooltip="Field length is calculated based on the size of the Value of a specific {{ tagSizeBytes === 1 ? 'UDH': 'TLV' }} field. In essence, it`s how many octets are used by the `Value`. It is automatically calculated by the platform.'"
                tooltipPlacement="top" tooltipClass="text-start">
              </span>
            </div>
            <span class="text-neutral-n7">{{getTagValue(model.valueHex)}}</span>
          </div>
          <div class="content">
            <div>
              Total {{tagSizeBytes === 1 ? 'UDH': 'TLV'}} Length
              <span class="icon-help-1 text-neutral-n6"
                tooltip="This refers to the sum of all octets that are part of the entire {{ tagSizeBytes === 1 ? 'User Data Header' : 'Tag, Length, Value' }}. In other words, it`s the combined size of all the {{tagSizeBytes === 1 ? 'UDH': 'TLV' }} fields (including their Tags, Lengths, and Values)."
                tooltipPlacement="top" tooltipClass="text-start">
              </span>
            </div>
            <span class="text-neutral-n7">{{getValue(model.valueHex)}}</span>
          </div>
        </div>
      </div>
      <a (click)="removeControls(model)" class="text-error-r2">
        <span class="far fa-trash-alt text-error-r2"></span> Remove
      </a>
    </div>
  </div>
</form>

<div class="bottom-container">
  <a class="btn btn-primary fs-6 px-20" *ngIf="!(models.length >= maxModels)" (click)="addControls({tagHex: '', valueHex: ''})">
    <span class="icon-add"></span> Add
  </a>
  <div class="bg-neutral-n3 mt-20 py-10 px-10" role="alert" *ngIf="tagSizeBytes === 1">
    <span class="simulated-text" [innerHTML]="'Simulated Full UDH:  ' + getSimulatedUdh()"
      [tooltip]="'Tag is represented by green color and value is represented by purple.'" [tooltipPlacement]="'top'">
    </span>
  </div>
  <div class="bg-neutral-n3 mt-20 py-10 px-10" role="alert" *ngIf="tagSizeBytes === 2"
    [tooltip]="'Tag is represented by green color and value is represented by purple.'" [tooltipPlacement]="'top'">
    <span class="simulated-text" [innerHTML]="'Simulated Full TLV:  ' + getSimulatedTlv()">
    </span>
  </div>
</div>
